import { toggle } from '@components/expandable/expandable.init';
import select from 'dom-select';

export const Accordion = (el) => {
  const ui = {
    el,
    control: select('.accordion__heading', el)
  };

  ui.control.addEventListener('keydown', (e) => {
    if (e.keyCode === 13) {
      ui.control.dispatchEvent(toggle);
    }
  });
};

export const AccordionGroup = (el) => {
  const ui = {
    el,
    accordions: select.all('.accordion')
  };

  const state = {
    controlled: ui.el.dataset.controlled
  };

  const onToggle = (target) => {
    ui.accordions.forEach((accordion) => {
      if (accordion !== target) { // any accordion in the group, sans the one clicked
        const hidden = accordion.querySelector('.expandable__drawer').getAttribute('aria-hidden');

        if (hidden === 'false') { // close it if it's open
          accordion.querySelector('.expandable').dispatchEvent(toggle);
        }
      }
    });
  };

  const addEvents = () => {
    ui.accordions.forEach((accordion) => {
      const accordionTrigger = select('.accordion__heading', accordion);

      accordionTrigger.addEventListener('click', () => onToggle(accordion));

      accordionTrigger.addEventListener('keydown', (e) => {
        if (e.keyCode === 13) {
          onToggle(accordion);
        }
      });
    });
  };

  const init = () => {
    // extra event for 'controlled' variant
    if (state.controlled === 'true') {
      addEvents();
    }
  };

  init();
};

export default Accordion;
